import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import locale from 'date-fns/locale/en-US';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import {
  Button, Label, RadioButtonGroup, RadioButton,
} from '@ipc/ipc-components';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { StyledModalForm } from '../../../../../common/list-table/helpers/formModal.styles';
import { getAllHandlers } from '../../redux/selectors/HandlersSelectors';
import {
  getAllHandlersRequestActionCreator,
} from '../../redux/actions/HandlersActions';

const filter = createFilterOptions();

function HandlerAssociateDialog(props) {
  const {
    openDialog,
    closeDialog,
    handlersOptions,
    associateHandler,
    fetchAllHandlers,
    selectedMrdDevice,
    currentMapping,
  } = props;

  useEffect(() => {
    fetchAllHandlers();
  }, []);

  const handlerOptions = handlersOptions.map((handler) => ({
    title: handler.handlerName,
    value: handler.handlerId,
  }));

  const [handlerName, updateHandlerName] = useState(null);
  const [receipt, updateReceipt] = useState(true);
  const [selectedValidFrom, setSelectedValidFrom] = useState(moment());
  const [selectedValidTo, setSelectedValidTo] = useState();
  const [validDate, setValidDate] = useState(true);
  const [validToValidDate, setValidToValidDate] = useState(true);
  const [isMappingOverlapped, setIsMappingOverlapped] = useState();

  const ischeckMappingOverlap = (handler, fromDate, toDate) => {
    let isOverlapped = false;
    const filteredArray = currentMapping.filter((row) => (row.handlerName.toUpperCase() === handler.toUpperCase()));
    filteredArray.map((index) => {
      if (!isOverlapped) {
        if (index.validTo === null && toDate === undefined) {
          isOverlapped = true;
        } else if (index.validTo !== null && toDate === undefined) {
          if (!moment(new Date(fromDate).setHours(0, 0, 0, 0)).isAfter(moment(index.validTo))) {
            isOverlapped = true;
          }
        } else if (index.validTo === null && toDate !== undefined) {
          if (!(moment(new Date(toDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom))
            && moment(new Date(fromDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom)))) {
            isOverlapped = true;
          }
        } else if (index.validTo !== null && toDate !== undefined) {
          if (!((moment(new Date(fromDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom))
            && moment(new Date(toDate).setHours(0, 0, 0, 0)).isBefore(moment(index.validFrom)))
            || (moment(new Date(fromDate).setHours(0, 0, 0, 0)).isAfter(moment(index.validTo))
              && moment(new Date(toDate).setHours(0, 0, 0, 0)).isAfter(moment(index.validTo))))) {
            isOverlapped = true;
          }
        }
      }
      return isOverlapped;
    });
    return isOverlapped;
  };

  const handleHandlerName = (event, newValue) => {
    let valid;
    if (typeof newValue === 'string' && newValue !== '' && newValue !== null && !newValue.isNaN) {
      let handlerText = newValue.trimStart();
      handlerText = handlerText.trimEnd();
      updateHandlerName({
        title: handlerText,
      });
      valid = ischeckMappingOverlap(handlerText, selectedValidFrom, selectedValidTo);
    } else if (newValue && newValue.inputValue) {
      // Create a new value from the user input
      let handlerText = newValue.inputValue.trimStart();
      handlerText = handlerText.trimEnd();
      updateHandlerName({
        title: handlerText,
      });
      valid = ischeckMappingOverlap(handlerText, selectedValidFrom, selectedValidTo);
    } else {
      updateHandlerName(newValue);
      valid = ischeckMappingOverlap(newValue.title, selectedValidFrom, selectedValidTo);
    }
    setIsMappingOverlapped(valid);
  };

  const handlePrintReceiptChange = (e) => {
    updateReceipt(e.target.value === 'true');
  };

  const onValidFromChange = (date) => {
    setSelectedValidFrom(moment(date));
    if (date !== null && date.toString() !== 'Invalid Date') {
      const valid = ischeckMappingOverlap(handlerName.title, date, selectedValidTo);
      setIsMappingOverlapped(valid);
    }
  };

  const onValidToChange = (date) => {
    setSelectedValidTo(date !== null ? moment(date) : undefined);
    const valid = ischeckMappingOverlap(handlerName.title, selectedValidFrom, date !== null ? date : undefined);
    setIsMappingOverlapped(valid);
  };

  const onInvalidDate = (message) => {
    setValidDate(message === '');
  };

  const onInvalidValidToDate = (message) => {
    setValidToValidDate(message === '');
  };

  function confirmSave() {
    let requestData;
    const filteredArray = currentMapping.filter((row) => (row.handlerName.toUpperCase() === handlerName.title.toUpperCase()));
    if (filteredArray.length > 0) {
      requestData = {
        handlerId: filteredArray[0].handlerId,
        handlerName: filteredArray[0].handlerName,
        printReceipt: receipt,
        validFrom: selectedValidFrom,
        validTo: selectedValidTo,
      };
    } else {
      requestData = {
        handlerId: Number(handlerName.value),
        handlerName: handlerName.title,
        printReceipt: receipt,
        validFrom: selectedValidFrom,
        validTo: selectedValidTo,
      };
    }
    associateHandler(requestData);
  }

  const isFormValid = () => !(handlerName === null
    || handlerName === undefined
    || handlerName.title === ''
    || handlerName.title === ' '
    || handlerName.title.isNaN
    || selectedValidFrom === null
    || selectedValidFrom === undefined
    || selectedValidFrom.toString() === 'Invalid Date'
    || (validDate === false)
    || (validToValidDate === false)
    || isMappingOverlapped !== false
    || (selectedValidTo !== undefined && moment(new Date(selectedValidFrom).setHours(0, 0, 0, 0)).isAfter(moment(new Date(selectedValidTo).setHours(0, 0, 0, 0)))));

  return (
    <Dialog onClose={closeDialog} aria-labelledby="simple-dialog-title" open={openDialog}>
      <StyledModalForm>
        <DialogTitle id="simple-dialog-title">Handler Association</DialogTitle>
        <div>
          <table className="form-details">
            <tbody>
              <tr>
                <td className="form-input-fields">
                  <Label>Device ID</Label>
                </td>
                <td className="form-input-fields">
                  <Label>{selectedMrdDevice.mrdName}</Label>
                </td>
              </tr>
              <tr>
                <td className="form-input-fields">
                  <Label>Handler Name*</Label>
                </td>
                <td className="form-input-fields">
                  <Autocomplete
                    value={handlerName}
                    onChange={handleHandlerName}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={handlerOptions}
                    size="small"
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      // Suggest the creation of a new value
                      if (params.inputValue !== '') {
                        filtered.push({
                          inputValue: params.inputValue.trimStart().trimEnd(),
                          title: `Add "${params.inputValue.trimStart().trimEnd()}"`,
                        });
                      }

                      return filtered;
                    }}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue.trimStart().trimEnd();
                      }
                      // Regular option
                      return option.title;
                    }}
                    renderOption={(option) => option.title}
                    style={{ width: 500 }}
                    freeSolo
                    fullWidth
                    className="handlers-dropdown"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        inputProps={{ ...params.inputProps, maxLength: 50 }}
                      />
                    )}
                  />
                </td>
              </tr>
              {(isMappingOverlapped === true) && (
                <tr>
                  <td />
                  <td>
                    <span style={{ color: 'red' }}>
                      Handler already exists for this MRD device.
                    </span>
                  </td>
                </tr>
              )}
              <tr>
                <td className="form-input-fields">
                  <Label>Print receipt</Label>
                </td>
                <td className="form-input-fields">
                  <RadioButtonGroup aria-label="receipt" name="receipt" onChange={handlePrintReceiptChange} value={receipt} row>
                    <RadioButton value label="Yes" />
                    <RadioButton value={false} label="No" />
                  </RadioButtonGroup>
                </td>
              </tr>
              <tr>
                <td className="form-input-fields">
                  <Label>Valid from*</Label>
                </td>
                <td className="form-input-fields">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container>
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        format="dd-MM-yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        minDate={moment(new Date())}
                        value={selectedValidFrom}
                        onChange={(e) => onValidFromChange(e)}
                        onError={onInvalidDate}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="form-input-fields">
                  <Label>Valid to</Label>
                </td>
                <td className="form-input-fields">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container>
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        format="dd-MM-yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        minDate={selectedValidFrom}
                        value={selectedValidTo !== undefined ? selectedValidTo : null}
                        onChange={(e) => onValidToChange(e)}
                        onError={onInvalidValidToDate}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={closeDialog}>Cancel</Button>
          <Button
            onClick={confirmSave}
            className={`primary-button-${!isFormValid()} action`}
            disabled={!isFormValid()}
            id="save"
          >
            Save
          </Button>
        </div>
      </StyledModalForm>
    </Dialog>
  );
}

HandlerAssociateDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool,
  associateHandler: PropTypes.func,
  handlersOptions: PropTypes.arrayOf(PropTypes.object),
  fetchAllHandlers: PropTypes.func,
  selectedMrdDevice: PropTypes.objectOf(PropTypes.any),
  currentMapping: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    handlersOptions: getAllHandlers(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchAllHandlers: getAllHandlersRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HandlerAssociateDialog);
